module.exports = __webpack_public_path__ + "img/link-2.c4be8f12.png";